import saveAs from "file-saver";

export function DownloadPdf(file: Blob, name: string) {
	saveAs(file, `${name}.pdf`);
}